import { useEffect } from 'react';

/**
 * Injects Google Analytics 4 (gtag) and Meta/Facebook Pixel ONLY when their IDs
 * are configured via env. No-ops otherwise, so placeholders can be filled later
 * without touching code.
 *   REACT_APP_GA_MEASUREMENT_ID  e.g. G-XXXXXXX
 *   REACT_APP_META_PIXEL_ID      e.g. 1234567890
 */
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

const AnalyticsScripts = () => {
  useEffect(() => {
    if (GA_ID && !window.__ga_loaded) {
      window.__ga_loaded = true;
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_ID);
    }

    if (PIXEL_ID && !window.__pixel_loaded) {
      window.__pixel_loaded = true;
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      /* eslint-enable */
    }
  }, []);

  return null;
};

export default AnalyticsScripts;
